module.exports = __webpack_public_path__ + "static/media/traycorp3.47bee14e.png";